module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.data_loading),
      expression: "data_loading"
    }],
    ref: "selected_ref",
    attrs: {
      "titles": ['未选角色', '已选角色'],
      "filterable": "",
      "filter-method": _vm.filterMethod,
      "filter-placeholder": "请输入角色名",
      "props": {
        key: 'role_id',
        label: 'role_des'
      },
      "data": _vm.data_all
    },
    model: {
      value: (_vm.data_selected),
      callback: function($$v) {
        _vm.data_selected = $$v
      },
      expression: "data_selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-913c422e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/user-role-transfer/user-role-transfer.vue
// module id = /NaV
// module chunks = 81